import { Legend } from '../../../types/common';

const colors = ['#FFFFB2', '#FECC5C', '#FD8D3C', '#F03B20', '#BD0026'];

const template = `
  <div class="covey-legend">
    <div class="covey-legend__title">Success Rate (%)</div>
    <div class="covey-legend__scale">
      <span>0</span>
      <span>100</span>
    </div>
    <div class="covey-legend__rates">
      ${colors
        .map(
          (color) => `
        <div class="covey-legend__rate" style="background-color: ${color}"></div>
      `,
        )
        .join('')}
    </div>
  </div>
`;

const rate = (): Legend => {
  const div = document.createElement('div');
  div.innerHTML = template;
  return div;
};

export default rate;
